/** Align with backend enum; extend when API exposes more values. */
export const BIG_QUERY_SYNC_TERMINAL_STATUSES: ReadonlySet<string> = new Set([
  'COMPLETED',
  'FAILED',
  'APPROVED',
  'APPLIED',
  'REJECTED',
  'CANCELLED',
]);

export const BIG_QUERY_SYNC_APPROVABLE_STATUSES: ReadonlySet<string> = new Set([
  'READY',
  'PREVIEW_READY',
  'AWAITING_APPROVAL',
]);

export function isTerminalBigQuerySyncJobStatus(status: string | null | undefined): boolean {
  if (!status) return false;
  return BIG_QUERY_SYNC_TERMINAL_STATUSES.has(status);
}

export function hasBigQuerySyncBlockedReason(blockedReason: string | null | undefined): boolean {
  return typeof blockedReason === 'string' && blockedReason.trim().length > 0;
}

export function canApproveOrRejectBigQuerySyncJob(
  status: string | null | undefined,
  blockedReason: string | null | undefined
): boolean {
  if (!status || hasBigQuerySyncBlockedReason(blockedReason)) return false;
  return BIG_QUERY_SYNC_APPROVABLE_STATUSES.has(status);
}
